const __WEBPACK_NAMESPACE_OBJECT__ = vixI18n;